import { render, staticRenderFns } from "./DisabledNavLink.vue?vue&type=template&id=15fe8132&scoped=true&"
import script from "./DisabledNavLink.vue?vue&type=script&lang=js&"
export * from "./DisabledNavLink.vue?vue&type=script&lang=js&"
import style0 from "./DisabledNavLink.vue?vue&type=style&index=0&id=15fe8132&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fe8132",
  null
  
)

export default component.exports